<div>
  <!-- leaderboard ad -->
  <div
    class="w-100 justify-content-center align-items-center d-none d-lg-flex py-3"
  >
    <div
      class="leaderboard-center skeleton leaderboard-skeleton"
      style="height: 104px;"
    ></div>
  </div>

  <main class="bg-white container container-fluid min-vh-100 pt-4">
    <div class="row">
      <div class="col-12 col-lg-8 pt-3 border-lg-right mb-10">
        <div class="two-column-container d-flex flex-column flex-md-row px-3">
          <div *ngFor="let col of [0,1]" class="w-100 w-md-50">
            <div *ngFor="let image of [0, 1, 2, 3, 4, 5]" class="w-100 d-flex flex-row search-result">
              <p class="p-skeleton w-100"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="d-none d-md-block col-lg-4 pt-3">
        <!-- right rail rectangle ad -->
        <div class="skeleton ad-rectangle-skeleton"></div>
      </div>
    </div>
  </main>
</div>
